import {createSlice} from '@reduxjs/toolkit';

export const settingsSlice = createSlice({
    name: 'settingsSlice',
    initialState: {
        currentGenerationSessionToken: "",
        currentGenerationSessionTokenNativeChat: "",
        currentPageAudiobook: 1,
        currentPageGrid: 1,
        currentPageGridGeneration: 1,
        currentPageGridAudiobooks: 1,
        isFullScreen: false,
        isChatVisible: true,
        isFollowUpVisible: false,
        isAskVisible: false,
        isAskImageVisible: false,
        followUpContent: null,
        askContent: null,
        askImageContent: null,
        isUploadLoading: false,
        currentChatInput: "",
        isUploadSourcesModalOpen: false,
        isViewSourcesModalOpen: false,
        isGeneratePDFVisible: false,
        currentGeneratePDF: "",
        currentGeneratePDFPage: 1,

        currentChatUserID: "",
        currentChatClaudeID: "",
        currentChatType: "",
        currentChatSelectionText: "",
        currentChatQuestion: "",
        currentChatResponse: "",

        isScanInProgress: true,
        isScanActuallyInProgress: false,
        isScanError: false,
        scanFileID: "",
        scanEstimatedSeconds: 0,
        scanType: "normal",
        celeryTaskID: "",

        isResearchModeOn: false,
        isNewFeatureOpen: true,
        isPricingModalOpen: false,
        isProPlan: false,
        whichTab: 1,

        isFollowUpVisibleGeneration: false,
        isAskVisibleGeneration: false,
        followUpContentGeneration: null,
        askContentGeneration: null,
        currentChatInputGeneration: "",
        currentChatUserIDGeneration: "",
        currentChatClaudeIDGeneration: "",
        currentChatTypeGeneration: "",
        currentChatSelectionTextGeneration: "",
        currentChatQuestionGeneration: "",
        currentChatResponseGeneration: "",

        currentGenerationProgress: -1,
        currentGenerationWordCount: -1,

        panelWidthPercentage: 50,
    },
    reducers: {
        setIsResearchModeOn: (state, action) => {
            state.isResearchModeOn = action.payload;
        },
        setPanelWidthPercentage: (state, action) => {
            state.panelWidthPercentage = action.payload;
        },
        setIsProPlan: (state, action) => {
            state.isProPlan = action.payload;
        },
        setIsPricingModalOpen: (state, action) => {
            state.isPricingModalOpen = action.payload;
        },
        setCurrentGeneratePDF: (state, action) => {
            state.currentGeneratePDF = action.payload;
        },
        setCurrentGeneratePDFPage: (state, action) => {
            state.currentGeneratePDFPage = action.payload;
        },
        setCurrentGenerationProgress: (state, action) => {
            state.currentGenerationProgress = action.payload;
        },
        setCurrentGenerationWordCount: (state, action) => {
            state.currentGenerationWordCount = action.payload;
        },
        setCurrentGenerationSessionToken: (state, action) => {
            state.currentGenerationSessionToken = action.payload;
        },
        setCurrentGenerationSessionTokenNativeChat: (state, action) => {
            state.currentGenerationSessionTokenNativeChat = action.payload;
        },
        setIsUploadSourcesModalOpen: (state, action) => {
            state.isUploadSourcesModalOpen = action.payload;
        },
        setIsViewSourcesModalOpen: (state, action) => {
            state.isViewSourcesModalOpen = action.payload;
        },
        toggleIsFollowUpVisibleTrueGeneration: (state) => {
            state.isFollowUpVisibleGeneration = true;
        },
        toggleIsFollowUpVisibleFalseGeneration: (state) => {
            state.isFollowUpVisibleGeneration = false;
        },
        toggleIsAskVisibleTrueGeneration: (state) => {
            state.isAskVisibleGeneration = true;
        },
        toggleIsAskVisibleFalseGeneration: (state) => {
            state.isAskVisibleGeneration = false;
        },
        setFollowUpContentGeneration: (state, action) => {
            state.followUpContentGeneration = action.payload;
        },
        setAskContentGeneration: (state, action) => {
            state.askContentGeneration = action.payload;
        },
        setCurrentChatInputGeneration: (state, action) => {
            state.currentChatInputGeneration = action.payload;
        },
        setCurrentChatUserIDGeneration: (state, action) => {
            state.currentChatUserIDGeneration = action.payload;
        },
        setCurrentChatClaudeIDGeneration: (state, action) => {
            state.currentChatClaudeIDGeneration = action.payload;
        },
        setCurrentChatTypeGeneration: (state, action) => {
            state.currentChatTypeGeneration = action.payload;
        },
        setCurrentChatSelectionTextGeneration: (state, action) => {
            state.currentChatSelectionTextGeneration = action.payload;
        },
        setCurrentChatQuestionGeneration: (state, action) => {
            state.currentChatQuestionGeneration = action.payload;
        },
        addToCurrentChatResponseGeneration: (state, action) => {
            state.currentChatResponseGeneration = state.currentChatResponseGeneration + action.payload;
        },
        resetCurrentChatResponseGeneration: (state) => {
            state.currentChatResponseGeneration = "";
        },


        setCurrentPageAudiobook: (state, action) => {
            state.currentPageAudiobook = action.payload;
        },
        setCurrentPageGrid: (state, action) => {
            state.currentPageGrid = action.payload;
        },
        setCurrentPageGridGeneration: (state, action) => {
            state.currentPageGridGeneration = action.payload;
        },
        setCurrentPageGridAudiobooks: (state, action) => {
            state.currentPageGridAudiobooks = action.payload;
        },
        toggleIsFullScreen: (state) => {
            state.isFullScreen = !state.isFullScreen;
        },
        toggleIsChatVisible: (state) => {
            state.isChatVisible = !state.isChatVisible;
        },
        setIsGeneratePDFVisible: (state, action) => {
            state.isGeneratePDFVisible = action.payload;
        },
        toggleIsFollowUpVisibleTrue: (state) => {
            state.isFollowUpVisible = true;
        },
        toggleIsFollowUpVisibleFalse: (state) => {
            state.isFollowUpVisible = false;
        },
        toggleIsAskVisibleTrue: (state) => {
            state.isAskVisible = true;
        },
        toggleIsAskVisibleFalse: (state) => {
            state.isAskVisible = false;
        },
        toggleIsAskImageVisibleTrue: (state) => {
            state.isAskImageVisible = true;
        },
        toggleIsAskImageVisibleFalse: (state) => {
            state.isAskImageVisible = false;
        },
        setFollowUpContent: (state, action) => {
            state.followUpContent = action.payload;
        },
        setAskContent: (state, action) => {
            state.askContent = action.payload;
        },
        setAskImageContent: (state, action) => {
            state.askImageContent = action.payload;
        },
        setIsUploadLoading: (state, action) => {
            state.isUploadLoading = action.payload;
        },
        setCurrentChatInput: (state, action) => {
            state.currentChatInput = action.payload;
        },
        setCurrentChatUserID: (state, action) => {
            state.currentChatUserID = action.payload;
        },
        setCurrentChatClaudeID: (state, action) => {
            state.currentChatClaudeID = action.payload;
        },
        setCurrentChatType: (state, action) => {
            state.currentChatType = action.payload;
        },
        setCurrentChatSelectionText: (state, action) => {
            state.currentChatSelectionText = action.payload;
        },
        setCurrentChatQuestion: (state, action) => {
            state.currentChatQuestion = action.payload;
        },
        addToCurrentChatResponse: (state, action) => {
            state.currentChatResponse = state.currentChatResponse + action.payload;
        },
        resetCurrentChatResponse: (state) => {
            state.currentChatResponse = "";
        },
        setScanEstimatedSeconds: (state, action) => {
            state.scanEstimatedSeconds = Math.max(action.payload / 2, 10);
        },
        setScanInProgress: (state, action) => {
            state.isScanInProgress = action.payload;
        },
        setScanError: (state, action) => {
            state.isScanError = action.payload;
        },
        setScanFileID: (state, action) => {
            state.scanFileID = action.payload;
        },
        setScanType: (state, action) => {
            state.scanType = action.payload;
        },
        setCeleryTaskID: (state, action) => {
            state.celeryTaskID = action.payload;
        },
        setIsNewFeatureOpen: (state, action) => {
            state.isNewFeatureOpen = action.payload;
        },
        setWhichTab: (state, action) => {
            state.whichTab = action.payload;
        },
        setIsScanActuallyInProgress: (state, action) => {
            state.isScanActuallyInProgress = action.payload;
        }
    },
});

export const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        user: null,
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        }
    },
});

export const documentSlice = createSlice({
    name: 'documentSlice',
    initialState: {
        savedDocuments: [],
        savedGenerations: [],
        savedGenerationsNative: [],
        savedVideos: [],
        savedAudiobooks: [],
        savedAnara: [],
    },
    reducers: {
        addDocument: (state, action) => {
            state.savedDocuments.unshift(action.payload);
            // Limit documents to prevent memory leaks - keep only last 50 documents
            if (state.savedDocuments.length > 400) {
                state.savedDocuments = state.savedDocuments.slice(0, 400);
            }
        },
        removeDocument: (state, action) => {
            state.savedDocuments = state.savedDocuments.filter((item) => item.id !== action.payload);
        },
        setDocuments: (state, action) => {
            state.savedDocuments = action.payload;
        },
        changeNameOfDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].name = action.payload.newName;
            }
        },
        setHighlightsInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].highlights = [...action.payload.newHighlights];
            }
        },
        setMessagesInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].messages = [...action.payload.newMessages];
            }
        },
        setGibberishFlagInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].isGibberish = action.payload.isGibberish;
            }
        },
        addMessageInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].messages.push(action.payload.messageToAdd);
                // Limit messages to prevent memory leaks - keep only last 100 messages
                if (state.savedDocuments[documentIndex].messages.length > 40) {
                    state.savedDocuments[documentIndex].messages = state.savedDocuments[documentIndex].messages.slice(-40);
                }
            }
        },
        removeMessageInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedDocuments[documentIndex].messages =
                    state.savedDocuments[documentIndex].messages.filter(message => message.id !== action.payload.messageID);
            }
        },
        appendToMessageInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedDocuments[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedDocuments[documentIndex].messages[messageIndex] = {
                        ...state.savedDocuments[documentIndex].messages[messageIndex],
                        response: state.savedDocuments[documentIndex].messages[messageIndex].response + action.payload.response,
                    };
                }
            }
        },
        updateMessageInDocument: (state, action) => {
            const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedDocuments[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedDocuments[documentIndex].messages[messageIndex] = {
                        ...state.savedDocuments[documentIndex].messages[messageIndex],
                        response: action.payload.response,
                        id: action.payload.messageID,
                        type: action.payload.type,
                    };
                }
            }
        },
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////






        addVideo: (state, action) => {
            state.savedVideos.unshift(action.payload);
            // Limit videos to prevent memory leaks - keep only last 50 videos
            if (state.savedVideos.length > 400) {
                state.savedVideos = state.savedVideos.slice(0, 400);
            }
        },
        // set a video by replacing it
        setOneVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.id);
            if (documentIndex !== -1) {
                state.savedVideos[documentIndex] = action.payload;
            }
        },
        removeVideo: (state, action) => {
            state.savedVideos = state.savedVideos.filter((item) => item.id !== action.payload);
        },
        setVideos: (state, action) => {
            state.savedVideos = action.payload;
        },
        changeNameOfVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedVideos[documentIndex].name = action.payload.newName;
            }
        },
        setMessagesInVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedVideos[documentIndex].messages = [...action.payload.newMessages];
            }
        },
        addMessageInVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedVideos[documentIndex].messages.push(action.payload.messageToAdd);
                // Limit messages to prevent memory leaks - keep only last 100 messages
                if (state.savedVideos[documentIndex].messages.length > 40) {
                    state.savedVideos[documentIndex].messages = state.savedVideos[documentIndex].messages.slice(-40);
                }
            }
        },
        removeMessageInVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedVideos[documentIndex].messages =
                    state.savedVideos[documentIndex].messages.filter(message => message.id !== action.payload.messageID);
            }
        },
        appendToMessageInVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedVideos[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedVideos[documentIndex].messages[messageIndex] = {
                        ...state.savedVideos[documentIndex].messages[messageIndex],
                        response: state.savedVideos[documentIndex].messages[messageIndex].response + action.payload.response,
                    };
                }
            }
        },
        updateMessageInVideo: (state, action) => {
            const documentIndex = state.savedVideos.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedVideos[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedVideos[documentIndex].messages[messageIndex] = {
                        ...state.savedVideos[documentIndex].messages[messageIndex],
                        response: action.payload.response,
                    };
                }
            }
        },









        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        addDocumentGeneration: (state, action) => {
            state.savedGenerations.unshift(action.payload);
            // Limit generations to prevent memory leaks - keep only last 50 generations
            if (state.savedGenerations.length > 400) {
                state.savedGenerations = state.savedGenerations.slice(0, 400);
            }
        },
        addDocumentGenerationNative: (state, action) => {
            state.savedGenerationsNative.unshift(action.payload);
            // Limit generations to prevent memory leaks - keep only last 50 generations
            if (state.savedGenerationsNative.length > 400) {
                state.savedGenerationsNative = state.savedGenerationsNative.slice(0, 400);
            }
        },
        removeDocumentGeneration: (state, action) => {
            state.savedGenerations = state.savedGenerations.filter((item) => item.id !== action.payload);
        },
        setDocumentsGeneration: (state, action) => {
            state.savedGenerations = action.payload;
        },
        setDocumentsGenerationNative: (state, action) => {
            state.savedGenerationsNative = action.payload;
        },
        changeNameOfDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].name = action.payload.newName;
            }
        },
        changeNameOfDocumentGenerationNative: (state, action) => {
            const documentIndex = state.savedGenerationsNative.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerationsNative[documentIndex].name = action.payload.newName;
            }
        },
        setMessagesInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].messages = [...action.payload.newMessages];
            }
        },
        setMessagesInDocumentGenerationNative: (state, action) => {
            const documentIndex = state.savedGenerationsNative.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerationsNative[documentIndex].messages = [...action.payload.newMessages];
            }
        },
        addMessageInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].messages.push(action.payload.messageToAdd);
                // Limit messages to prevent memory leaks - keep only last 100 messages
                if (state.savedGenerations[documentIndex].messages.length > 40) {
                    state.savedGenerations[documentIndex].messages = state.savedGenerations[documentIndex].messages.slice(-40);
                }
            }
        },
        removeMessageInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].messages =
                    state.savedGenerations[documentIndex].messages.filter(message => message.id !== action.payload.messageID);
            }
        },
        clearMessagesInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].messages = [];
            }
        },
        appendToMessageInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedGenerations[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedGenerations[documentIndex].messages[messageIndex] = {
                        ...state.savedGenerations[documentIndex].messages[messageIndex],
                        response: state.savedGenerations[documentIndex].messages[messageIndex].response + action.payload.response,
                    };
                }
            }
        },
        updateMessageInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedGenerations[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedGenerations[documentIndex].messages[messageIndex] = {
                        ...state.savedGenerations[documentIndex].messages[messageIndex],
                        response: action.payload.response,
                        sourcesList: action.payload.sourcesList,
                        supportsList: action.payload.supportsList,
                    };
                }
            }
        },
        updateMessageInDocumentGeneration2: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedGenerations[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedGenerations[documentIndex].messages[messageIndex] = {
                        ...state.savedGenerations[documentIndex].messages[messageIndex],
                        response: action.payload.response,
                        tableResponse: action.payload.tableResponse,
                    };
                }
            }
        },
        // set the files in a savedGeneration by doing something like this: setFiles(files => files.map((f, i) => i === fileIndex ? { ...f, status: 'error' } : f));
        setFilesInDocumentGeneration: (state, action) => {
            const documentIndex = state.savedGenerations.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerations[documentIndex].files = [...action.payload.newFiles];
            }
        },
        setFilesInDocumentGenerationNative: (state, action) => {
            const documentIndex = state.savedGenerationsNative.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedGenerationsNative[documentIndex].files = [...action.payload.newFiles];
            }
        },
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        addAudiobook: (state, action) => {
            state.savedAudiobooks.unshift(action.payload);
            // Limit audiobooks to prevent memory leaks - keep only last 50 audiobooks
            if (state.savedAudiobooks.length > 400) {
                state.savedAudiobooks = state.savedAudiobooks.slice(0, 400);
            }
        },
        removeAudiobook: (state, action) => {
            state.savedAudiobooks = state.savedAudiobooks.filter((item) => item.id !== action.payload);
        },
        setAudiobooks: (state, action) => {
            state.savedAudiobooks = action.payload;
        },
        changeNameOfAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].name = action.payload.newName;
            }
        },
        // setHighlightsInDocument: (state, action) => {
        //     const documentIndex = state.savedDocuments.findIndex(doc => doc.id === action.payload.documentID);
        //     if (documentIndex !== -1) {
        //         state.savedDocuments[documentIndex].highlights = [...action.payload.newHighlights];
        //     }
        // },
        setMessagesInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].messages = [...action.payload.newMessages];
            }
        },
        setOutlineInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].outline = [...action.payload.outline];
            }
        },
        addMessageInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].messages.push(action.payload.messageToAdd);
                // Limit messages to prevent memory leaks - keep only last 100 messages
                if (state.savedAudiobooks[documentIndex].messages.length > 40) {
                    state.savedAudiobooks[documentIndex].messages = state.savedAudiobooks[documentIndex].messages.slice(-40);
                }
            }
        },
        addAudioInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].pageAudioURLs.push(action.payload.audioToAdd);
            }
        },
        clearAudioInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].pageAudioURLs = [];
            }
        },
        removeMessageInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                state.savedAudiobooks[documentIndex].messages =
                    state.savedAudiobooks[documentIndex].messages.filter(message => message.id !== action.payload.messageID);
            }
        },
        appendToMessageInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedAudiobooks[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedAudiobooks[documentIndex].messages[messageIndex] = {
                        ...state.savedAudiobooks[documentIndex].messages[messageIndex],
                        response: state.savedAudiobooks[documentIndex].messages[messageIndex].response + action.payload.response,
                    };
                }
            }
        },
        updateMessageInAudiobook: (state, action) => {
            const documentIndex = state.savedAudiobooks.findIndex(doc => doc.id === action.payload.documentID);
            if (documentIndex !== -1) {
                const messageIndex = state.savedAudiobooks[documentIndex].messages.findIndex(message => message.id === action.payload.messageID);
                if (messageIndex !== -1) {
                    state.savedAudiobooks[documentIndex].messages[messageIndex] = {
                        ...state.savedAudiobooks[documentIndex].messages[messageIndex],
                        response: action.payload.response,
                    };
                }
            }
        },

    },
});

export const sidePanelSlice = createSlice({
    name: 'sidePanelSlice',
    initialState: {
        isSidePanelOpen: false,
        sidebarWidth: "83px",
    },
    reducers: {
        toggleSidePanel: (state) => {
            state.isSidePanelOpen = !state.isSidePanelOpen;
            state.sidebarWidth = state.isSidePanelOpen ? "240px" : "83px";
        }
    },
});

export const { setCurrentPageAudiobook, setCurrentPageGrid, setPanelWidthPercentage } = settingsSlice.actions;
export const { setUser } = userSlice.actions;
export const { addDocument, removeDocument,
    addAudiobook, setDocuments, setAudiobooks } = documentSlice.actions;
export const { setHighlightsInDocument, addMessageInDocument,
    removeMessageInDocument, appendToMessageInDocument, updateMessageInDocument,
    setMessagesInDocument, setGibberishFlagInDocument, setMessagesInAudiobook,
    setOutlineInAudiobook, addAudioInAudiobook, clearAudioInAudiobook,
    changeNameOfDocument, changeNameOfAudiobook,
    setMessagesInDocumentGeneration, setMessagesInDocumentGenerationNative,
    removeMessageInDocumentGeneration, clearMessagesInDocumentGeneration,
    appendToMessageInDocumentGeneration, updateMessageInDocumentGeneration,
    updateMessageInDocumentGeneration2,
    addMessageInDocumentGeneration, addVideo,
    removeVideo, setVideos, setOneVideo,
    changeNameOfVideo, setMessagesInVideo,
    addMessageInVideo, removeMessageInVideo,
    appendToMessageInVideo,
    updateMessageInVideo} = documentSlice.actions;

export const { toggleIsFullScreen, toggleIsChatVisible,
    setAskContent, setFollowUpContent,
    toggleIsFollowUpVisibleTrue, setIsGeneratePDFVisible,
    toggleIsFollowUpVisibleFalse, toggleIsAskVisibleFalse,
    toggleIsAskVisibleTrue, setIsUploadLoading, setCurrentChatInput,
    setCurrentChatUserID, setCurrentChatClaudeID, setCurrentChatType,
    setCurrentChatQuestion, setCurrentChatSelectionText,
    addToCurrentChatResponse, resetCurrentChatResponse,
    setScanEstimatedSeconds, setScanInProgress,
    setScanFileID, setScanType,
    setCeleryTaskID, setIsNewFeatureOpen,
    setIsScanActuallyInProgress, setIsResearchModeOn,
    setCurrentChatInputGeneration, addToCurrentChatResponseGeneration,
    resetCurrentChatResponseGeneration, setWhichTab,
    setAskContentGeneration, setCurrentChatClaudeIDGeneration,
    setCurrentChatQuestionGeneration, setCurrentChatSelectionTextGeneration,
    setFollowUpContentGeneration, toggleIsAskVisibleFalseGeneration,
    toggleIsFollowUpVisibleTrueGeneration, setCurrentChatTypeGeneration,
    setCurrentChatUserIDGeneration, toggleIsAskVisibleTrueGeneration,
    toggleIsFollowUpVisibleFalseGeneration,
    setIsUploadSourcesModalOpen,
    setIsViewSourcesModalOpen,
    setCurrentPageGridGeneration, setCurrentPageGridAudiobooks,
    setCurrentGenerationSessionToken, setCurrentGenerationSessionTokenNativeChat,
    setCurrentGeneratePDF,
    setCurrentGenerationProgress, setCurrentGeneratePDFPage,
    setCurrentGenerationWordCount,
    setIsPricingModalOpen,
    setIsProPlan,
    setAskImageContent,
    toggleIsAskImageVisibleTrue,
    setScanError,
    toggleIsAskImageVisibleFalse} = settingsSlice.actions;
export const { toggleSidePanel } = sidePanelSlice.actions;
export const {setDocumentsGeneration, setDocumentsGenerationNative,
    addDocumentGeneration, addDocumentGenerationNative
    , removeDocumentGeneration,
    changeNameOfDocumentGeneration, changeNameOfDocumentGenerationNative,
    setFilesInDocumentGeneration, setFilesInDocumentGenerationNative,
    updateProgressInGenerationFile,
    updateStatusInGenerationFile, specialUpdateProgressInGenerationFile,
    appendFilesInDocumentGeneration} = documentSlice.actions;

export default {
    "settingsSliceReducer": settingsSlice.reducer,
    "userSliceReducer": userSlice.reducer,
    "documentSliceReducer": documentSlice.reducer,
    "sidePanelSliceReducer": sidePanelSlice.reducer,
}
